<template>
  <div class="feed-item no-img" data-spm-type="resource">
    <a :href="feedData.url" target="_blank" class="feed-item__box" :data-mphref="feedData.personalPage">
      <div class="feed-item__content">
        <h5 class="feed-item__title">{{ feedData.title }}</h5>
        <p class="feed-item__des">{{ feedData.brief }}</p>
        <div class="feed-item__footer">
          <a class="auther-box" :href="feedData.personalPage">
            <img class="auther-img" :src="feedData.authorPic" alt="作者头像" />
            <span class="auther__name">{{ feedData.authorName }}</span>
          </a>
          <span class="time">{{ feedData.fixTime }}</span>
        </div>
      </div>
    </a>
    <div style="clear: both"></div>
  </div>
</template>

<script>
export default {
  props: {
    feedData: {
      type: Object,
      required: true,
      default: () => ({
        url: '',
        personalPage: '',
        title: '',
        brief: '',
        authorPic: '',
        authorName: '',
        fixTime: ''
      })
    }
  }
};
</script>

<style scoped>
</style>
